<template>
    <div class="glide" ref="carousel">
        <div class="glide__track" data-glide-el="track">
            <ul class="glide__slides">
                <li class="glide__slide" v-for="item in helloBarData" :key="item.title">
                    <div class="hello-bar-item">
                        <div class="hello-bar-text" v-html="item.message"></div>
                        <div class="hello-bar-links">
                            <div v-if="item.callToAction1.link" class="hello-bar-button btn btn-Primary-White btn-compact">
                                <a class="hello-bar-link" v-bind:target="getTarget(item.callToAction1.link)"
                                   v-bind:aria-label="getTarget(item.callToAction1.link) === '_blank' ? `${item.callToAction1.label} - ${openTabText}` : null"
                                   :href="item.callToAction1.link">
                                    {{ item.callToAction1.label }}
                                    <i v-if="item.callToAction1.icon" v-bind:class="item.callToAction1.icon"></i>
                                </a>
                            </div>
                            <div v-if="item.callToAction2.link" class="hello-bar-button btn btn-Primary-White btn-compact">
                                <a class="hello-bar-link" v-bind:target="getTarget(item.callToAction2.link)"
                                   v-bind:aria-label="getTarget(item.callToAction2.link) === '_blank' ? `${item.callToAction2.text} - ${openTabText}` : null"
                                   :href="item.callToAction2.link">
                                    {{ item.callToAction2.label }}
                                    <i v-if="item.callToAction2.icon" v-bind:class="item.callToAction2.icon"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div data-glide-el="controls" v-if="helloBarData.length > 1">
            <button class="fass fa-angle-left slider__arrow slider__arrow--prev glide__arrow glide__arrow--prev" :aria-label="previousText" data-glide-dir="<"></button>
            <button class="fass fa-angle-right slider__arrow slider__arrow--next glide__arrow glide__arrow--next" :aria-label="nextText" data-glide-dir=">"></button>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { Glide, Controls, Keyboard, Swipe } from 'base/js/templates/general/carouselUtils.js';

const carousel = ref(null);
const hostname = window.location.hostname;
const { helloBarData, previousText, nextText, openTabText } = defineProps({
    helloBarData: {
        type: Object,
        required: true
    },
    previousText: {
        type: String,
        required: true
    },
    nextText: {
        type: String,
        required: true
    },
    openTabText: {
        type: String,
        required: true
    }
});
const getTarget = (link => {
    if (link.startsWith('/') || link.startsWith('#')) {
        return '';
    } else if (!link.includes(hostname) || link.includes('http')) {
        return '_blank';
    }
})

onMounted(initCarousel);

function initCarousel() {
    const el = carousel.value;

    const modules = {
        Controls: Controls,
        Keyboard: Keyboard,
        Swipe: Swipe
    };
    const options = {
        type: 'carousel',
        perView: 1,
        keyboard: true
    };

    const glide = new Glide(el, options);

    if (helloBarData.length > 1) {
        glide.mount(modules);
    }
}
</script>